<template>
  <div>
    <!-- create product modal -->
    <form @submit.prevent="createProduct">
      <modal
        v-show="isCreateProductModalVisible"
        @close="closeCreateProductModal"
        footer
      >
        <template v-slot:title>
          <h5>Add Product</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="form-group">
              <label for="name">Product Name</label>
              <input
                type="text"
                v-model.trim="product.name"
                class="form-control"
                placeholder="i.e. Berekete,   e.t.c"
              />
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <textarea
                placeholder="About The Product"
                name="description"
                v-model="product.description"
                id=""
                cols="30"
                rows="5"
                class=" form-control"
                style="resize: none"
              ></textarea>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="interest_rate">Interest Rate (%)</label>
                <input
                  placeholder="Interest Percentage"
                  type="text"
                  class="form-control"
                  v-model="product.interest_rate"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="interest_rate_type">Interest Rate Type</label>
                <select
                  name="interest_rate_type"
                  id=""
                  class="form-control"
                  v-model="product.interest_rate_type"
                >
                  <option value="" selected disabled
                    >Select Interest Rate Type</option
                  >
                  <option value="fixed">Fixed</option>
                  <option value="float">Float</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="min_amount">Minimum Amount (&#8358;)</label>
                <input
                  type="text"
                  placeholder="5,000"
                  @keyup="formatAmountWithComma"
                  v-model="product.min_amount"
                  class=" form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="max_amount">Maximum Amount (&#8358;)</label>
                <input
                  type="text"
                  placeholder="50,000"
                  @keyup="formatMaxAmountWithComma"
                  v-model="product.max_amount"
                  class=" form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="grace_period">Grace Period (Days)</label>
                <input
                  type="text"
                  placeholder=""
                  v-model="product.grace_period"
                  class=" form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="discount_interest_rate"
                  >Discount Interest Rate (%)</label
                >
                <input
                  type="text"
                  placeholder="discount rate"
                  v-model="product.discount_interest_rate"
                  class=" form-control"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="margin_finance">Margin Finance (%)</label>
              <input
                type="text"
                v-model="product.margin_finance"
                class=" form-control"
                placeholder="Margin Finance"
              />
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="min_term">Minimum Term (Months)</label>
                <input
                  type="text"
                  v-model="product.min_term"
                  class=" form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="max_term">Maximum Term (Months)</label>
                <input
                  type="text"
                  v-model="product.max_term"
                  class=" form-control"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="penalty">Penalty</label>
              <select
                name="penalty"
                v-model="product.penalty"
                class=" form-control"
              >
                <option value="" selected disabled
                  >Select Penalty Option</option
                >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="!formIsValid || creatingProductLoading"
          >
            <span class="custom-loader" v-if="creatingProductLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                <!-- {{ad.id ? "Updating ad..." : "Adding ad..."}} -->
                Creating Product...
              </span>
            </span>
            <span v-else>
              <!-- {{ ad.id ? "Updating ad" : "Add ad" }} -->
              Create Product
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeCreateProductModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <!-- main page -->
    <loader-ring v-if="getProductsLoading" class="loader-center"></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Products</h1>
        </div>
        <div class="col-auto">
          <button
            class="button button--outline text-uppercase"
            @click="showCreateProductModal"
          >
            Create Product
          </button>
        </div>
      </div>
      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h3 class="card-title">Products</h3>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="products"
              :fields="fields"
              :itemsPerPage="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #min_amount="{item}">
                <td class="table--action-mobile">
                  &#8358;{{ Number(item.min_amount).toLocaleString() }}
                </td>
              </template>
              <template #max_amount="{item}">
                <td class="table--action-mobile">
                  &#8358;{{ Number(item.max_amount).toLocaleString() }}
                </td>
              </template>
              <template #actions="{item}">
                <td class="table--action-mobile">
                  <router-link
                    class="button"
                    :to="{
                      name: 'ProductComponent',
                      params: { slug: item.id }
                    }"
                  >
                    View Product
                  </router-link>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
const fields = [
  "name",
  "interest_rate",
  "interest_rate_type",
  "min_amount",
  "max_amount",
  "actions"
];
export default {
  name: "Products",
  data() {
    return {
      small: true,
      fields,
      getProductsLoading: false,
      isCreateProductModalVisible: false,
      creatingProductLoading: false,
      products: [],
      product: {
        name: "",
        description: "",
        interest_rate: "",
        min_amount: "",
        max_amount: "",
        min_term: "",
        max_term: "",
        margin_finance: "",
        penalty: "",
        interest_rate_type: "",
        discount_interest_rate: "",
        grace_period: ""
      }
    };
  },
  components: {
    CDataTable
  },
  computed: {
    removeCommaFromMinAccount() {
      return this.product.min_amount.toString().replace(/,/g, "");
    },
    removeCommaFromMaxAccount() {
      return this.product.max_amount.toString().replace(/,/g, "");
    },
    formIsValid() {
      return (
        this.product.name !== "" &&
        this.product.description !== "" &&
        this.product.interest_rate !== "" &&
        this.product.interest_rate_type !== "" &&
        this.product.min_amount !== "" &&
        this.product.min_term !== "" &&
        this.product.max_amount !== "" &&
        this.product.discount_interest_rate !== "" &&
        this.product.grace_period !== "" &&
        this.product.max_term !== "" &&
        this.product.margin_finance !== "" &&
        this.product.penalty !== ""
      );
    }
  },
  methods: {
    formatAmountWithComma() {
      let result = this.product.min_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.product.min_amount = result));
    },
    formatMaxAmountWithComma() {
      let result = this.product.max_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.product.max_amount = result));
    },
    showCreateProductModal() {
      this.isCreateProductModalVisible = true;
    },
    closeCreateProductModal() {
      this.isCreateProductModalVisible = false;
    },
    async createProduct() {
      this.creatingProductLoading = true;
      console.log(this.product);
      let newObj = {
        ...this.product,
        min_amount: parseFloat(this.removeCommaFromMinAccount),
        max_amount: parseFloat(this.removeCommaFromMaxAccount)
      };
      console.log(newObj);
      try {
        const response = await ApiService.post(
          "backend/loan/product/create-loan-product",
          newObj
        );

        this.creatingProductLoading = false;
        this.closeCreateProductModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getProducts(), 2356);
      } catch (error) {
        this.closeCreateProductModal();
        this.creatingProductLoading = false;

        this.product = {};
        let _error = error.response.data;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
        console.log(error.response);
      }
    },
    async getProducts() {
      this.getProductsLoading = true;
      try {
        const response = await ApiService.get("backend/loan/product/all");

        this.products = response.data.data;
        this.getProductsLoading = false;
      } catch (error) {
        this.getProductsLoading = false;
        console.log(error.response);
      }
    }
  },
  mounted() {
    this.getProducts();
  }
};
</script>

<style scoped></style>
